import DeleteOutlined from '@mui/icons-material/DeleteOutlined';

export const FilterPanelDeleteIcon = () => <DeleteOutlined />;
